import vExpansion from './Expansion';

export { vExpansion };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Expansion/index.js